// extracted by mini-css-extract-plugin
module.exports = {"marquee":"reviewsMarquee_marquee__seGDy","track":"reviewsMarquee_track__qoTY9","reviews-scroll":"reviewsMarquee_reviews-scroll__PI7x_"};